import {NotificationSoundKey, DEFAULT_NOTIFICATION_SOUND_KEY} from '../../service/notificationSounds';

export const SET_NOTIFICATION_SOUND = 'SET_NOTIFICATION_SOUND';

export interface SetNotificationSoundAction {
  type: typeof SET_NOTIFICATION_SOUND;
  payload: NotificationSoundKey;
}

export type NotificationSoundDispatchTypes = SetNotificationSoundAction;

export interface NotificationSoundState {
  selectedSoundKey: NotificationSoundKey;
}

const initialState: NotificationSoundState = {
  selectedSoundKey: DEFAULT_NOTIFICATION_SOUND_KEY,
};

export const SetNotificationSound = (soundKey: NotificationSoundKey) => ({
  type: SET_NOTIFICATION_SOUND,
  payload: soundKey,
});

const notificationSoundReducer = (
  state: NotificationSoundState = initialState,
  action: NotificationSoundDispatchTypes,
): NotificationSoundState => {
  switch (action.type) {
    case SET_NOTIFICATION_SOUND:
      return {
        ...state,
        selectedSoundKey: action.payload ?? DEFAULT_NOTIFICATION_SOUND_KEY,
      };
    default:
      return state;
  }
};

export default notificationSoundReducer;
